import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { ReviewsService } from '../reviews.service';
import { Global } from '../classes/Global';
import { StringHelper } from '../helpers/StringHelper';
import { StorageHelper } from '../helpers/StorageHelper';
import { DateHelper } from '../helpers/DateHelper';
import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss'],
  providers: [ ReviewsService ]
})
export class ReviewComponent extends BaseComponent implements OnInit {

  @Input() review;
  @ViewChild('text', {static: true}) text;
  @ViewChild('textMobile', {static: true}) textMobile;
  @ViewChild('reviewText', {static: false}) reviewText;
  @ViewChild('reviewTextMobile', {static: false}) reviewTextMobile;
  @Output() onEdit = new EventEmitter();
  @Output() needAuth = new EventEmitter();

  showMore: boolean = false;

  constructor(
    private reviewsService: ReviewsService,
    private authService: AuthenticationService
  ) {
    super();
  }

  ngOnInit() {

  }

  textIsLong(): boolean {
    if(this.text) {
      return this.text.nativeElement.offsetHeight > 140;
    }
    return false;
  }

  textMobileIsLong(): boolean {
    if(this.textMobile) {
      return this.textMobile.nativeElement.offsetHeight > 140;
    }
    return false;
  }

  scale() {
    let reviewText = this.reviewText.nativeElement;
    let height = this.text.nativeElement.offsetHeight;
    if(height == 0) {
      height = this.textMobile.nativeElement.offsetHeight
      reviewText = this.reviewTextMobile.nativeElement;
    }

    if(this.showMore) {
      reviewText['style'].height = height + 25 + "px";
      reviewText['style'].maxHeight = height + 25 + "px";
    }
    else {
      reviewText['style'].height = null;
      reviewText['style'].maxHeight = null;
    }
  }

  getReviewPic() {
    const src = this.review && this.review.profileImageUrl? this.review.profileImageUrl : "placeholder";
    return src.includes('.')? src : "./assets/images/profile_placeholder.png";
  }

  formatDate(date) {
    return DateHelper.serverDateToLocaleDate(date);
  }

  upvote() {

    if(this.authService.isLoggedIn()) {
      this.reviewsService.doUpvote(this.review.id, "itunes", StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), 
      Global.getCountry()).subscribe(res => {
        if(res && res["status"] == "success") {
          this.review.upVotes++;
          if(this.review.upVotes > this.review.totalVotes) {
            this.review.totalVotes++;
          }
        }
      }, err => {
        
      });
    }
    else {
      this.needAuth.emit();
    }
    
  }

  downvote() {

    if(this.authService.isLoggedIn()) {

      this.reviewsService.doDownvote(this.review.id, "itunes", StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), 
      Global.getCountry()).subscribe(res => {
        if(res && res["status"] == "success") {
          if(this.review.upVotes > 0) { this.review.upVotes--; }
          if(this.review.totalVotes == 0) {
            this.review.totalVotes++;
          }
        }
      }, err => {

      });
    } else {
      this.needAuth.emit();
    }
  }

  getVotesText(): string {
    if(this.review.totalVotes == 0) {
      return this.getString('noReviewsVotesText');
    }
    return StringHelper.format(this.getString('reviewsVotesText'), this.review.upVotes, this.review.totalVotes);
  }

  showEdit(): boolean {
    const now = new Date();
    return this.review.username == StorageHelper.getInstance().get(StorageHelper.keys.username) &&
    now.getTime() < (new Date(this.review.dateCreated.value).getTime() + 600000);
  }

  edit() {
    this.onEdit.emit();
  }

}
